import React from 'react';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

export default class Loader extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {

    }

    render() {
        let value = parseInt(this.props.percent) * 863.3 / 100;
        let errorMsg =  this.props.response !== null ? this.props.response.toUpperCase() : '';
        let visibleClass = classNames({
            'active-loader': parseInt(this.props.percent) !== 100 && this.props.response === null,
            'success' : this.props.response !== null && this.props.response === "success",
            'error': this.props.response === "error"
        });
        return (
        <div className="loader__background">
            <svg x="0px" y="0px"
                 width="279.12px" height="279.12px" viewBox="0 0 279.12 279.12" className={visibleClass}>
                <g id="Progress_x5F_bar">
                    <circle id="Dark_x5F_stroke" cx="139.56" cy="139.56" r="137.34"
                            fill="none"
                            stroke="#242127" strokeWidth="4" strokeMiterlimit="10"/>

                    <linearGradient id="Color_x5F_stroke_1_" gradientUnits="userSpaceOnUse" x1="13.2454" y1="198.6315"
                                    x2="265.8746" y2="80.8285" gradientTransform="matrix(1 0 0 -1 0 279.2899)">
                        <stop offset="5.533854e-03" style={{stopColor: "#37F0E9"}}/>
                        <stop offset="0.9904" style={{stopColor: "#14CFB7"}}/>
                    </linearGradient>
                    <circle id="Color_x5F_stroke" cx="139.56" cy="139.56" r="137.34" fillRule="evenodd"
                            clipRule="evenodd"
                            fill="none" stroke="url(#Color_x5F_stroke_1_)" strokeWidth="4" strokeMiterlimit="10"
                            strokeDasharray="863.3" strokeDashoffset={863.3-value}
                            style={{transform: 'rotate(-90deg)', transformOrigin: 'center'}}/>
                </g>
                <g id="Upload_x5F_txt">
                    <text transform="matrix(1 0 0 1 92.1806 170.2711)">
                        <tspan fill="#00D9D1" fontFamily="Realist Narrow"
                               fontSize="18px">
                            {Translator.trans('media_uploader.uploading', [], 'app')}
                        </tspan>
                    </text>
                    <text transform="matrix(1 0 0 1 80 195)">
                        <tspan fill="white" fontSize="18px"
                               fontFamily="Realist Narrow">{parseFloat(this.props.uploaded * 0.000001).toFixed(2)}mb
                        </tspan>
                        <tspan fill="#00D9D1" fontFamily="Realist Narrow"
                               fontSize="18px"> / {parseFloat(this.props.size * 0.000001).toFixed(2)}mb
                        </tspan>
                    </text>
                    <text transform="matrix(1 0 0 1 105 130.5485)" style={{textAlign: 'center'}}>
                        <tspan x="0" y="0" fill="white" fontSize="60px" fontFamily="Realist Narrow">
                            {parseInt(this.props.percent)}
                            <tspan fill="white" fontSize="40px" fontFamily="Realist Narrow">%</tspan>
                        </tspan>
                    </text>
                </g>
                <g id="Completed">
                    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="113.4592" y1="197.5562"
                                    x2="172.3564"
                                    y2="170.092" gradientTransform="matrix(1 0 0 -1 0 279.2899)">
                        <stop offset="5.533854e-03" style={{stopColor: "#37F0E9"}}/>
                        <stop offset="0.9904" style={{stopColor: "#14CFB7"}}/>
                    </linearGradient>
                    <polyline points="104.91,104.8 130.48,136.29 188.4,70.06 	" display="inline"
                              fill="none"
                              stroke="url(#SVGID_1_)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"
                              strokeMiterlimit="10"/>
                    <text transform="matrix(1 0 0 1 80.2866 182.5744)" fill="white"
                          fontSize="28px"
                          display="inline" fontFamily="Realist Narrow">{Translator.trans('media_uploader.completed', [], 'app')}
                    </text>
                </g>
                <g id="Error">
                    <linearGradient id="red_x5F_stroke_1_" gradientUnits="userSpaceOnUse" x1="13.2454" y1="1001.3686"
                                    x2="265.8746" y2="1119.1716" gradientTransform="matrix(1 0 0 1 0 -920.7101)">
                        <stop offset="0" style={{stopColor: "#FFA874"}}/>
                        <stop offset="0.9947" style={{stopColor:"#EE1B1C"}}/>
                    </linearGradient>
                    <circle id="red_x5F_stroke" cx="139.56" cy="139.56" r="137.34" fill="none"
                            stroke="url(#red_x5F_stroke_1_)" strokeWidth="4" strokeMiterlimit="10"/>
                    <linearGradient id="x_1_" gradientUnits="userSpaceOnUse" x1="85.7506" y1="89.9032" x2="193.3694"
                                    y2="140.0866">
                        <stop offset="0.0124" style={{stopColor:"#FF2F30"}}/>
                        <stop offset="0.9904" style={{stopColor:"#FF2F30"}}/>
                    </linearGradient>
                    <path id="x" d="M96.39,158.17l86.34-86.34 M182.73,158.17L96.39,71.82" fill="none"
                                                stroke="url(#red_x5F_stroke_1_)" strokeWidth="4" strokeMiterlimit="10"/>
                </g>
                <g id="Error_text">
                    <text transform="matrix(1 0 0 1 80.2866 182.5744)" fill="white"
                                 fontSize="28px"
                                 display="inline" fontFamily="Realist Narrow">{errorMsg}
                           </text>
                </g>
            </svg>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/Loader.jsx